var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.06 2.44a1.5 1.5 0 0 0-2.12 0l-5 5a1.5 1.5 0 1 0 2.12 2.12l2.44-2.439V16.5a1.5 1.5 0 0 0 3 0V7.121l2.44 2.44a1.5 1.5 0 0 0 2.12-2.122l-5-5ZM5.5 16a1.5 1.5 0 0 0-3 0v1.153c0 1.326 0 2.49.153 3.459.169 1.073.537 2.015 1.324 2.86 1.484 1.59 3.304 1.715 5.492 1.865l.305.021c1.227.086 2.636.142 4.226.142 1.59 0 2.999-.056 4.226-.142l.305-.02c2.188-.15 4.008-.275 5.492-1.866.787-.845 1.155-1.787 1.324-2.86.153-.97.153-2.133.153-3.46V16a1.5 1.5 0 0 0-3 0v1.048c0 1.462-.004 2.388-.116 3.097-.1.63-.268.973-.556 1.28-.597.641-1.163.755-3.811.94A57.607 57.607 0 0 1 14 22.5a57.61 57.61 0 0 1-4.017-.134c-2.648-.186-3.214-.3-3.811-.94-.288-.308-.457-.65-.556-1.281-.112-.71-.116-1.635-.116-3.097V16Z",
    fill: "currentColor",
    fillOpacity: 0.92
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload28);
export default __webpack_public_path__ + "static/media/upload_28.bf9197f2.svg";
export { ForwardRef as ReactComponent };